import Vue from 'vue'
import Vuex from 'vuex';
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import App from './App.vue'
import router from './router'
import './registerServiceWorker'
import VueCharts from 'vue-chartjs';
import Axios from 'axios';
import VueAxios from 'vue-axios';
import VueFormWizard from 'vue-form-wizard';
import 'vue-form-wizard/dist/vue-form-wizard.min.css';
import store from '@/store';
import VueAuth from '@websanova/vue-auth';
import VueEvents from 'vue-events';

Vue.config.productionTip = false
Vue.prototype.$http = Axios;
const prodUrl = process.env.VUE_APP_BASE_URI;
const devUrl = process.env.VUE_APP_BASE_URI;

Vue.prototype.$baseApi = process.env.NODE_ENV === 'production' ? prodUrl : devUrl;
Vue.prototype.$billingUrl = process.env.VUE_APP_BILLING_URL;
Vue.prototype.$timeTracking = process.env.VUE_APP_TIME_TRACKING_URL;

Vue.use(Antd);
Vue.use(VueFormWizard);
Vue.use(VueCharts)
Vue.use(Vuex);
Vue.use(VueEvents);
Vue.use(VueAxios, Axios);
Vue.router = router;
Vue.use(VueAuth, {
  auth: require("@websanova/vue-auth/drivers/auth/bearer"),
  rolesVar: "role_name",
  http: require("@websanova/vue-auth/drivers/http/axios.1.x.js"),
  router: require("@websanova/vue-auth/drivers/router/vue-router.2.x"),
  // authRedirect: {
  //   name: 'login'
  // },
  loginData: {
    url: Vue.prototype.$baseApi.replace("api/", "") + "/login",
    fetchUser: true,
    method: "POST"
  },
  logoutData: {
    url: Vue.prototype.$baseApi.replace("api/", "") + "/logout",
    method: "POST"
  },
  refreshData: {
    url: process.env.VUE_APP_BASE_URI.replace("api/", "") + "/me",
    method: "GET",
    enabled: true,
    error: () => {
      Vue.auth.logout();
    },
    success: () => {},
    done: () => {

    },
    interval: 30
  },
  fetchData: {
    url: process.env.VUE_APP_BASE_URI.replace("api/", "") + "/me",
    method: "GET",
    enabled: true,
    success: () => {}
  },
  forbiddenRedirect: "/403",
  parseUserData: res => res.data
});
new Vue({
  router,
  store: new Vuex.Store(store),
  render: h => h(App)
}).$mount('#app')